import api from '../axios';

export const get_records = async (data) => {
  try {
    const response = await api.post('/records', data);
    return response.data;
  } catch (error) {
    console.error('Error fetching records:', error);
    return null;
  }
};

export const rollback_renovation_customer = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.post(`/records/rollback/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error rolling back renovation:', error);
    return null;
  }
};
